import { ap1, na2, na3 } from 'hubspot-url-utils/hublets-next';
export const BETA_HUBLETS = [na3, na2, ap1];